import Vue from 'vue'
import Router from 'vue-router'

const index = () => import(/* webpackChunkName:'home'*/ '@/pages/index/index'); //首页
const metaIndex = () => import(/* webpackChunkName:'home'*/ '@/pages/index/metaIndex'); //首页
const wava = () => import(/* webpackChunkName:'wava'*/ '@/pages/wava/wava'); //测试
const login = () => import(/* webpackChunkName:'login'*/ '@/pages/login/login'); //登录页
const detail = () => import(/* webpackChunkName:'detail'*/ '@/pages/detail/detail'); //登录页

Vue.use(Router)
export default new Router({
  mode: 'history',
  base:'',
  routes: [
    {path: '/',name: 'index',component: index,meta: {title: ''}},
    {path: '/metaIndex',name: 'index',component: metaIndex,meta: {title: ''}},
    {path: '/wava',name: 'wava',component: wava,meta: {title: ''}},
    {path: '/login',name: 'login',component: login,meta: {title: ''}},
    {path: '/detail',name: 'detail',component: detail,meta: {title: ''}},
  ],
})



// WEBPACK FOOTER //
// ./src/router/index.js